import {
  AntTextArea,
  Checkbox,
  DatePicker,
  Input,
  UploadComment,
} from "components/Antd";
import {
  AutocompleteDebounce,
  CommonButton,
  RippleEffect,
  // VideoElement,
} from "components/UiElement";
import moment from "moment";
import { dobFormate } from "helpers";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { validation } from "./validation";

function ModalForm({
  setDetailModal,
  onSubmit,
  onePhoto,
  loading,
  setOnePhoto,
  subscriptionData,
}) {
  const { t } = useTranslation();
  const [coverUrl, setCoverUrl] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    (onePhoto?.date) ? dayjs(onePhoto?.date) : ''
  );
  const initialValues = {
    date: onePhoto?.date || undefined,
    title: onePhoto?.title || "",
    description: onePhoto?.description || "",
    albumImage: onePhoto?.albumImage || "",
    location: onePhoto?.location || undefined,
    lat: onePhoto?.lat || "",
    long: onePhoto?.long || "",
    isDownloadable:
      onePhoto &&
      onePhoto?.isDownloadable &&
      onePhoto?.isDownloadable === onePhoto?.albumImage
        ? 1
        : 0 || 0,
  };

  useEffect(() => {
    setCoverUrl(onePhoto?.albumImageUrl);
  }, []);

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={(val) => {
        if (!coverUrl) {
          val.filePath = "";
        }
        let data = { ...val };
        if (val.location === "" || val.location === undefined) {
          data.lat = "";
          data.long = "";
          data.location = "";
        }
        if (val.date) {       
          const parsedDate = moment(val.date, dobFormate); // Parse the date
          if (parsedDate.isValid()) {
            data.date = parsedDate.format("YYYY-MM-DD"); // Format
          }
        }
        onSubmit(data);
      }}
      validationSchema={validation()}
      enableReinitialize
    >
      {(props) => {
        return (
          <Form>
            <div className="d-sm-flex w-100">
              <div className="commentModel_left text-break">
                <h2>Upload Photo, Pdf, Audio or Video</h2>
                <UploadComment
                  setCoverUrl={setCoverUrl}
                  coverUrl={coverUrl}
                  props={props}
                  filePath={coverUrl}
                  name="albumImage"
                  aspect={1.2}
                  step={2}
                  fileName="album-photo"
                  query
                  subscriptionData={subscriptionData}
                  extraClassName="d-flex flex-wrap justify-content-between position-relative"
                />
              </div>
              <div className="commentModel_right">
                <Row>
                  <Col lg={6}>
                    <div className="form-group">
                      <label className="form-label">Date</label>
                      <DatePicker
                        className="form-control"
                        placeholder="Select Date"
                        name="date"
                        suffixIcon={<em className="icon-calendar" />}
                        onSelectChange={(e) => {
                         if(e){ 
                          setSelectedDate(dayjs(e));
                          props.setFieldValue("date", dayjs(e));
                        }}}
                        value={selectedDate}
                        validation
                         defaultValue={
                          onePhoto?.date === null ||
                          onePhoto?.date === undefined
                            ? undefined
                            : dayjs(onePhoto?.date)
                                        }
                        disabledDate={(current) => {
                          return current && current > dayjs().endOf("day");
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group">
                      <label className="form-label">Location</label>
                      <AutocompleteDebounce
                        defaultValue={onePhoto?.location}
                        validation
                        name="location"
                        placeholder="Enter Location"
                        setFieldValue={props.handleChange}
                        callBack={(val) => {
                          props.setFieldValue(
                            "location",
                            val?.formatted_address
                          );
                          props.setFieldValue(
                            "lat",
                            val?.geometry?.location?.lat()
                          );
                          props.setFieldValue(
                            "long",
                            val?.geometry?.location?.lng()
                          );
                        }}
                      />{" "}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group">
                      <label className="form-label">Title</label>
                      <Input
                        className="form-control"
                        placeholder="Enter Title "
                        setFieldvalue={props.handleChange}
                        name="title"
                      />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group customComment">
                      <label className="form-label">Description</label>
                      <AntTextArea
                        placeholder="Description"
                        className="form-control"
                        style={{ resize: "none", height: "auto" }}
                        rows="3"
                        name="description"
                        maxLength={250}
                        setFieldvalue={props.handleChange}
                      />
                    </div>
                  </Col>{" "}
                  <Col md={12}>
                    <div className="d-flex">
                      <div>
                        <Checkbox
                          name="isDownloadable"
                          defaultChecked={
                            onePhoto &&
                            onePhoto?.isDownloadable &&
                            onePhoto?.isDownloadable === onePhoto?.albumImage
                              ? 1
                              : 0 || 0
                          }
                        >
                          {"   "} Please Check to make Images/Videos
                          downloadable.
                        </Checkbox>
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="commentModel_btn d-flex justify-content-end">
                  <RippleEffect>
                    <Button
                      className="btn btn-light"
                      onClick={() => {
                        setDetailModal(false);
                        setOnePhoto();
                      }}
                    >
                      {t("text.common.close")}{" "}
                    </Button>
                  </RippleEffect>
                  <RippleEffect>
                    <CommonButton
                      className="btn btn-danger"
                      type="submit"
                      loading={loading}
                    >
                      {onePhoto
                        ? t("text.common.update")
                        : t("text.common.add")}
                    </CommonButton>
                  </RippleEffect>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ModalForm;
